
const initialSate = () => ({
  isCallInprogress: false,
  applications: {
    totalElements: 1,
    page: 0,
    records: [],
  },
  constants: {
    STATUS: [],
  },
  regionList: [],
});

export default initialSate;
